import axios from 'axios'

// URL base dell'API per le petizioni, recuperato dall'env file

const PETIZIONI_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'petizione'

const headers = { 'Content-Type': 'application/json' }

class PetizioniService {

    /**
     * Recupera tutte le petizioni disponibili nel sistema.
     * Effettua una richiesta GET a `/petizione/all`.
     *
     * @returns {Promise} - Una promessa che restituisce la lista di tutte le petizioni.
     */
    getAll() {
        return axios.get(PETIZIONI_REST_API_URL + "/all")
    }

    /**
     * Recupera tutte le petizioni associate a un determinato comune.
     * Effettua una richiesta GET a `/petizione/comune/{comId}`.
     *
     * @param {number} comId - L'ID del comune per cui recuperare le petizioni.
     * @returns {Promise} - Una promessa che restituisce la lista delle petizioni del comune specificato.
     */
    findByComune(comId) {
        return axios.get(PETIZIONI_REST_API_URL + `/comune/${comId}`)
    }

    /**
     * Salva o aggiorna una petizione nel sistema.
     * Effettua una richiesta POST a `/petizione/save` con i dati della petizione.
     *
     * @param {Object} petizione - Oggetto contenente i dettagli della petizione da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    savePetizione(petizione) {
        return axios.post(PETIZIONI_REST_API_URL + "/save", petizione, headers)
    }

     /**
     * Recupera una petizione specifica in base al suo ID.
     * Effettua una richiesta GET a `/petizione/{petId}`.
     *
     * @param {number} petId - L'ID della petizione da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli della petizione.
     */
    getPetizione(petId) {
        return axios.get(PETIZIONI_REST_API_URL + `/${petId}`)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const petizioniServiceInstance = new PetizioniService()
export default petizioniServiceInstance